var COMPONENT_TYPES = {
    Navigation: "navigation",
};
export { COMPONENT_TYPES };
